import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'

import EventEditActionButtons from '@/pages/CreateEventProcessingPage/ui/layout/EventEditActionButtons.vue'
import { IEventEdit } from '@/enitites/event'
import BKInput from '@/components/AppShared/BKInput.vue'
import { ISetPaymentSystemPayloadDisabled } from '@/modules/Payment/types'
import { useSetPaymentSystem } from '@/modules/Payment/api/queries'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateEventOwnPaymentSystem',
  props: {
    eventData: null
  },
  emits: ["next", "back", "cancel"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'next'): void
  (e: 'back'): void
  (e: 'cancel'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  eventData: IEventEdit
};

const { mutate: setPaymentSystem, isPending, error } = useSetPaymentSystem()





const priceRange = ref<string | undefined>(props.eventData.paymentSystem?.priceRange)
const paymentUrl = ref<string>(props.eventData.paymentSystem?.purchaseTicketsExternalUrl || '')

function saveEventData(onSuccess: () => void) {
  if (isPending.value) return

  const payload: ISetPaymentSystemPayloadDisabled = {
    isEnabled: false,
    priceRange: priceRange.value || 'Not specified',
    purchaseTicketsExternalUrl: paymentUrl.value,
  }

  setPaymentSystem(
    {
      eventId: props.eventData.id,
      payload,
    },
    { onSuccess }
  )
}

function handleNext() {
  saveEventData(() => {
    emit('next')
  })
}

function handleCancel() {
  saveEventData(() => {
    emit('cancel')
  })
}

return { __sfc: true,setPaymentSystem, isPending, error, props, emit, priceRange, paymentUrl, saveEventData, handleNext, handleCancel, EventEditActionButtons, BKInput }
}

})